import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=252e2e52&"
import script from "./CopyModal.vue?vue&type=script&lang=ts&"
export * from "./CopyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports